var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0599 0C5.84537 0 0 5.59476 0 12.5C0 19.4052 5.84537 25 13.0599 25C20.2745 25 26.1199 19.4052 26.1199 12.5C26.1199 5.59476 20.2745 0 13.0599 0ZM17.9305 15.7762L16.8773 17.0363C16.8082 17.119 16.7227 17.1879 16.6258 17.239C16.5289 17.2901 16.4224 17.3224 16.3124 17.3341C16.2024 17.3458 16.0911 17.3366 15.9849 17.3072C15.8786 17.2777 15.7794 17.2285 15.693 17.1623L12.1647 14.6562C11.9182 14.4673 11.7192 14.2278 11.5824 13.9553C11.4457 13.6828 11.3747 13.3844 11.3748 13.0822V5.24194C11.3748 5.02805 11.4636 4.82293 11.6216 4.67169C11.7796 4.52045 11.9939 4.43548 12.2174 4.43548H13.9025C14.126 4.43548 14.3403 4.52045 14.4983 4.67169C14.6563 4.82293 14.7451 5.02805 14.7451 5.24194V12.5L17.7994 14.6421C17.8859 14.7083 17.9578 14.7902 18.0112 14.883C18.0646 14.9759 18.0984 15.0778 18.1105 15.1832C18.1227 15.2885 18.1131 15.3951 18.0822 15.4968C18.0513 15.5986 17.9998 15.6935 17.9305 15.7762Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e54fd3d2dff643963ecd9778f48e0760.svg";
export { ForwardRef as ReactComponent };